import { format, isSameDay, parse } from "date-fns";
import React from "react";
import { useParams } from "react-router-dom";
import Event from "./Event";
import Weather from "./Weather";
import useSheets from "./utils/useSheets";

export default function TodayView(props) {
  const { events, today } = useSheets({ view: "today" });
  const match = useParams<{ community: string }>();

  // console.log("events", events);

  // function onClick(location) {
  //   params.set("location", location);
  //   push(`?${params.toString()}`);
  // }

  // if (params.get("location")) {
  //   return <LocationView />;
  // }

  return (
    <React.Fragment>
      <header className="header header--week">
        <div className="header__logo">
          <img src={`/img/logo-stacked.png`} alt="logo" />
        </div>
        <h1 className="header__title">
          {format(today, "EEEE, MMMM d")}{" "}
          <span className="header__title-date">
            {format(today, "h:mm aaaa")}
          </span>
        </h1>
        <div className="header__weather">
          <Weather />
        </div>
      </header>
      <header className="header header--no-bg">
        <h1 className="header__title">Today in the Community</h1>
      </header>
      <div className={`calendar-container ${match.community}`}>
        <div className="table table--today">
          <div className="thead">
            <div className="th th--times">Times</div>
            <div className="th th--activities">Activities</div>
            <div className="th th--location">Location</div>
          </div>
          <div className="tbody">
            {events
              .filter((e) => {
                const eventDate = parse(e["Event-Date"], "M/d/yy", new Date());

                return (
                  isSameDay(eventDate, today) &&
                  e["Event-Name"] !== "Move In" &&
                  !e["Memory Care Calendar?"] &&
                  !e["Holiday?"]
                );
              })
              .map((e, i) => {
                return (
                  <React.Fragment key={i}>
                    <Event
                      event={e}
                      type="today"
                      locationIcons
                      community={match.community}
                    />
                  </React.Fragment>
                );
              })}
          </div>
          <div className="map__meta">All times subject to change.</div>
        </div>

        {match.community === "durham" && (
          <div className="map map--today">
            <div className="legend__item legend__item--map legend__item--center">
              <div className="legend__icon legend__icon--center"></div>
              <div className="legend__item-title">Community Center</div>
            </div>
            <div className="legend__item legend__item--map legend__item--d-wing">
              <div className="legend__icon legend__icon--d-wing"></div>
              <div className="legend__item-title">D Wing</div>
            </div>
            <div className="legend__item legend__item--map legend__item--c-wing">
              <div className="legend__icon legend__icon--c-wing"></div>
              <div className="legend__item-title">C Wing</div>
            </div>
            <div className="legend__item legend__item--map legend__item--b-wing">
              <div className="legend__icon legend__icon--b-wing"></div>
              <div className="legend__item-title">B Wing</div>
            </div>
            <div className="legend__item legend__item--map legend__item--a-wing">
              <div className="legend__icon legend__icon--a-wing"></div>
              <div className="legend__item-title">A Wing</div>
            </div>
          </div>
        )}

        {match.community === "fuquay" && (
          <div className="map map--today map--fuquay">
            <div className="legend__item legend__item--map legend__item--center">
              <div className="legend__icon legend__icon--center"></div>
              <div className="legend__item-title">Community Center</div>
            </div>
            <div className="legend__item legend__item--map legend__item--c-wing">
              <div className="legend__icon legend__icon--c-wing"></div>
              <div className="legend__item-title">C Wing</div>
            </div>
            <div className="legend__item legend__item--map legend__item--b-wing">
              <div className="legend__icon legend__icon--b-wing"></div>
              <div className="legend__item-title">B Wing</div>
            </div>
            <div className="legend__item legend__item--map legend__item--a-wing">
              <div className="legend__icon legend__icon--a-wing"></div>
              <div className="legend__item-title">A Wing</div>
            </div>
            <div className="legend__item legend__item--map legend__item--outdoor">
              <div className="legend__icon legend__icon--outdoor"></div>
              <div className="legend__item-title">Outdoor Spaces</div>
            </div>
          </div>
        )}

        {match.community === "wakefield" && (
          <div className="map map--today map--wakefield"></div>
        )}

        {match.community === "apex" && (
          <div className="map map--today map--apex"></div>
        )}
      </div>
    </React.Fragment>
  );
}
